export default "__VITE_ASSET__CQp0LvLM__"